import React, { Component } from "react";
import CustomScroll from "react-custom-scroll";
import { NavLink } from "react-router-dom";
import SwitchComponent from "../../../App";
import classes from "./LeftNavigation.css";
import Aux1 from "../../../hoc/Aux1/Aux1";
import NavigationItems from "../NavigationItems/NavigationItems";
const toggleClass = () => {
  var element = document.getElementById("sideNavigation");
  element.classList.toggle("opened");
  console.log(1)
};
const leftNavigation = (props) => {
  return (
    <Aux1>
      <aside className="sidenav" id="sideNavigation">
        <div className="toggleBtn"  onClick={toggleClass} >Expand</div>
        <CustomScroll>
          <div className="navContent">
            <ul className="list-unstyled">
              <NavigationItems isAuthenticated={props.isAuth} />
            </ul>
          </div>
        </CustomScroll>
      </aside>

      {SwitchComponent}
    </Aux1>
  );
};

export default leftNavigation;
